import React from "react";
import "../styles/TimerCircle.css";

const TimerCircle = ({ time, maxTime, isWork }) => {
    const radius = 100;
    const circumference = 2 * Math.PI * radius;

    // Progres kruhu při odpočítávání
    const progress = ((maxTime - time) / maxTime) * circumference;

    return (
        <div className="timer-container">
            <svg viewBox="0 0 240 240" width="100%" height="100%">
                {/* Šedý pozadí kruhu */}
                <circle
                    cx="120"
                    cy="120"
                    r={radius}
                    stroke="#e0e0e0"
                    strokeWidth="30"
                    fill="none"
                />
                {/* Přibývající kruh */}
                <circle
                    className="progress-circle"
                    cx="120"
                    cy="120"
                    r={radius}
                    stroke={isWork ? "#E51937" : "#1c192c"}
                    strokeWidth="30"
                    fill="none"
                    strokeDasharray={circumference}
                    strokeDashoffset={circumference - progress}
                    strokeLinecap="round"
                    transform="rotate(-90 120 120)"
                />
                {/* Čas ve středu kruhu */}
                <text
                    x="120"
                    y="130"
                    textAnchor="middle"
                    fontSize="5rem"
                    fontWeight="bold"
                    fill="#333"
                >
                    {time}
                </text>
            </svg>
        </div>
    );
};

export default TimerCircle;
